import { Action } from '@ngrx/store';
import { ErrorEntity, ErrorEntityInterface, ErrorInterface, ErrorStatus } from 'app/core/error-handler/models/index';

import { ErrorActionType } from './error-action-type.model';

export class ErrorHandled implements Action {
  public readonly type: ErrorActionType = ErrorActionType.ErrorHandled;

  constructor(public readonly payload: ErrorEntityInterface) { }
}

export function createErrorHandled(error: ErrorInterface): ErrorHandled {
  return new ErrorHandled(new ErrorEntity({
    ...error,
    status: ErrorStatus.Handled,
  }));
}

